import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 4C3 3.44771 3.44772 3 4 3H8.53333C9.08562 3 9.53333 3.44772 9.53333 4V10.5333C9.53333 11.0856 9.08562 11.5333 8.53333 11.5333H4C3.44771 11.5333 3 11.0856 3 10.5333V4Z"
      fill="#24275B"
    />
    <path
      d="M10.4667 4C10.4667 3.44771 10.9144 3 11.4667 3H16C16.5523 3 17 3.44772 17 4V6.53333C17 7.08562 16.5523 7.53333 16 7.53333H11.4667C10.9144 7.53333 10.4667 7.08562 10.4667 6.53333V4Z"
      fill="#24275B"
    />
    <path
      d="M10.4667 9.46667C10.4667 8.91438 10.9144 8.46667 11.4667 8.46667H16C16.5523 8.46667 17 8.91438 17 9.46667V16C17 16.5523 16.5523 17 16 17H11.4667C10.9144 17 10.4667 16.5523 10.4667 16V9.46667Z"
      fill="#24275B"
    />
    <path
      d="M3 13.4667C3 12.9144 3.44772 12.4667 4 12.4667H8.53333C9.08562 12.4667 9.53333 12.9144 9.53333 13.4667V16C9.53333 16.5523 9.08562 17 8.53333 17H4C3.44771 17 3 16.5523 3 16V13.4667Z"
      fill="#24275B"
    />
  </svg>
);
